import { render, staticRenderFns } from "./revoke-owner.vue?vue&type=template&id=65a134e5&"
import script from "./revoke-owner.vue?vue&type=script&lang=ts&"
export * from "./revoke-owner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports